import { render } from "./CollectionSection.vue?vue&type=template&id=bdfd322e"
import script from "./CollectionSection.vue?vue&type=script&lang=js"
export * from "./CollectionSection.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/zaytoon-mtn-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__